import { Logger } from '@opentelemetry/api-logs';
import { SET_TELEMETRY_LOGGER } from '../../constants/actionConstants';

export const setTelemetryLogger = (logger: Logger) => ({
  type: SET_TELEMETRY_LOGGER,
  payload: logger,
});
